import { Icon } from "../icons/icon";

export const FormCard = ({
  title,
  text,
  mode = "view",
  icon = "",
  className = "",
  barClassName = "",
  bodyClassName = "",
  iconWidth = 12,
  iconHeight = 12,
  onRemove,
}: {
  title: string;
  text: string;
  mode?: "view" | "edit";
  icon?: string;
  className?: string;
  barClassName?: string;
  bodyClassName?: string;
  iconWidth?: number;
  iconHeight?: number;
  onRemove?: () => void;
}) => {
  return (
    <div
      className={`
        w-full rounded-[8px]
        border border-pry-dark-green-300/10
        ${mode === "view" ? "p-3 bg-light-green-bg" : "p-2"}
        ${className}
        `}
    >
      {mode === "edit" && (
        <div className="flex flex-row gap-1 justify-between items-center">
          <div
            className={`
            flex-1 flex flex-row gap-1
            items-center text-[10px] text-white
            bg-pry-green-300 px-[4px] py-[2px]
            rounded-[4px]
            ${barClassName}
            `}
          >
            <Icon svg={icon} width={iconWidth} height={iconHeight} />

            <p className="capitalize">{title}</p>
          </div>

          {!!onRemove && (
            <button
              type="button"
              className="w-fit"
              onClick={() => {
                onRemove();
              }}
            >
              <Icon
                svg="close-icon"
                width={20}
                height={20}
                className={`text-pry-green-300 cursor-pointer`}
              />
            </button>
          )}
        </div>
      )}

      <p
        className={`text-xs capitalize ${
          mode === "edit" && "text-pry-green-200 mt-2"
        } ${bodyClassName}`}
      >
        {text}
      </p>
    </div>
  );
};
